/* eslint-disable default-case */
/* eslint-disable no-negated-condition */
/* eslint-disable no-unused-expressions */
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { ChangeEvent, useEffect, useState } from "react";
import { changedPhoneComponent } from "../../../../redux/slices/flowupdates";
import {
  Baloon,
  ButtonPlus,
  ButtonTrash,
  Flex,
  ImageSixPoints,
  TextArea,
  Span,
  ImgIcon
} from "./styles";
import {
  A,
  Actions,
  Attachment,
  ButtonDelete,
  Link,
  MicBlue,
  SixPoints,
  Smile,
  spaik,
  ThreePointsBlue
} from "../../../../assets";
import { Text } from "../../../Text";
import {
  addNodeFallBack,
  deleteNodeFallback,
  updateNodeFallBackMessage
} from "../../../../redux/slices/nodes";
import { AuthContextType, useAuth } from "../../../../auth/auth-provider";
import {
  setAudioModalOpen,
  setEmojiModalOpen,
  setSendFileModalOpen,
  setSendsendFileSelectorSOOpenOpen,
  setIdxEmoji,
  textEmoji,
  setbotInteractionIDActive,
  setModalOpenRobotActions
} from "../../../../redux/slices/flowInteractions";
import { Tooltip } from "primereact/tooltip";
import { EmojiModal } from "../../components/interacaoRobo/EmojiModal";
import { OptionsExceptionsRobotActions } from "../interacaoRobo/OptionsExceptions";

export const Exceptions: React.FC = () => {
  const dispatch = useAppDispatch();
  const nodes = useAppSelector((state) => state.nodes);
  const nodeSelected = nodes.find((node) => node.selected === true);
  const nodeSelectedFallBack = nodeSelected?.data?.fallbackMessages;
  const nodeId = nodeSelected?.id;
  const [firstFallbackMessage, setFirstFallbackMessage] = useState("");
  const { user } = useAuth() as AuthContextType;
  const idxEmoji = useAppSelector((state) => state.flowInteractions.idxEmoji);
  const emoji = useAppSelector(
    (state) => state.flowInteractions.valueTextEmoji
  );
  const fallbackEmojiIdx = -1;
  const [cursorPosition, setCursorPosition] = useState<number>(0);
  const [activeFallbackIndex, setActiveFallbackIndex] = useState<number>(-1);
  const [showRobotActions, setShowRobotActions] = useState<boolean>(false);
  const actionExceptionsRobot = useAppSelector(
    (state) => state.flowInteractions.actionExceptionsRobot
  );

  const handleUpdate = (e: ChangeEvent<HTMLTextAreaElement>, idx: number) => {
    dispatch(
      updateNodeFallBackMessage({ newMessage: e.target.value, nodeId, idx })
    );
  };
  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (!e.ctrlKey) {
      return null;
    }
    switch (e.key) {
      case "Enter": {
        e.preventDefault();
        if (nodeSelectedFallBack?.length) {
          nodeSelected && dispatch(addNodeFallBack({ nodeId }));
        } else {
          nodeSelected && dispatch(addNodeFallBack({ nodeId }));
          firstFallbackMessage.length &&
            dispatch(
              updateNodeFallBackMessage({
                newMessage: firstFallbackMessage,
                nodeId,
                idx: 0
              })
            );
          setFirstFallbackMessage("");
        }
        dispatch(changedPhoneComponent(true));
        break;
      }
      default:
        return null;
    }
  };

  const handleAddFallbackMessage = () => {
    if (nodeSelectedFallBack?.length) {
      nodeSelected && dispatch(addNodeFallBack({ nodeId }));
    } else {
      nodeSelected && dispatch(addNodeFallBack({ nodeId }));
      firstFallbackMessage.length &&
        dispatch(
          updateNodeFallBackMessage({
            newMessage: firstFallbackMessage,
            nodeId,
            idx: 0
          })
        );
      setFirstFallbackMessage("");
    }
    dispatch(changedPhoneComponent(true));
  };
  const handleDelete = (idx: number) => {
    nodeSelected && dispatch(deleteNodeFallback({ nodeId, idx }));
    dispatch(changedPhoneComponent(true));
  };
  useEffect(() => {
    if (!nodeSelectedFallBack?.length && firstFallbackMessage?.length) {
      nodeSelected && dispatch(addNodeFallBack({ nodeId }));
      firstFallbackMessage?.length &&
        dispatch(
          updateNodeFallBackMessage({
            newMessage: firstFallbackMessage,
            nodeId,
            idx: 0
          })
        );
      setFirstFallbackMessage("");
    }
  }, [firstFallbackMessage?.length]);

  const autoResize = (el: HTMLTextAreaElement | null) => {
    if (!el) return;

    el.style.height = "0px";
    const scrollHeight = el.scrollHeight;

    el.style.height = `${scrollHeight}px`;
    el.style.overflowY = "hidden";
  };

  useEffect(() => {
    if (!emoji) return;
    if (idxEmoji !== fallbackEmojiIdx) return;

    if (
      activeFallbackIndex >= 0 &&
      nodeSelectedFallBack &&
      typeof nodeId !== "undefined"
    ) {
      const currentText = nodeSelectedFallBack[activeFallbackIndex] ?? "";
      const beforeCursor = currentText.slice(0, cursorPosition);
      const afterCursor = currentText.slice(cursorPosition);
      const newText = beforeCursor + emoji + afterCursor;

      dispatch(
        updateNodeFallBackMessage({
          newMessage: newText,
          nodeId,
          idx: activeFallbackIndex
        })
      );
    } else {
      const currentText = firstFallbackMessage ?? "";
      const beforeCursor = currentText.slice(0, cursorPosition);
      const afterCursor = currentText.slice(cursorPosition);
      const newText = beforeCursor + emoji + afterCursor;
      setFirstFallbackMessage(newText);
    }

    dispatch(textEmoji(""));
    dispatch(setEmojiModalOpen(false));
  }, [
    emoji,
    idxEmoji,
    cursorPosition,
    activeFallbackIndex,
    nodeId,
    nodeSelectedFallBack,
    firstFallbackMessage
  ]);

  const showOptions = () => {
    setShowRobotActions(true);
  };

  useEffect(() => {
    console.log("valor: ", actionExceptionsRobot);
    if (actionExceptionsRobot === "newDialog") {
      handleAddFallbackMessage();
    } else if (actionExceptionsRobot === "newVariable") {
      console.log("adc variavel");
    }
  }, [actionExceptionsRobot]);

  return (
    <div className="flex bg-white justify-content-start flex-column p-2 mt-4">
      <EmojiModal heightEmojiPicker="320px" />
      <OptionsExceptionsRobotActions
        openModal={showRobotActions}
        setOpenModal={setShowRobotActions}
      />
      <div
        style={{ border: "3px solid rgba(33, 150, 243, 0.3)" }}
        className="relative mt-2 p-2 w-full border-round-lg"
      >
        <div className="absolute -mt-4 ml-6 bg-white border-round-right-3xl flex">
          <div className="flex align-items-center">
            <div className="w-2rem h-2rem -ml-4 shadow-7 text-center border-circle bg-white flex align-items-center justify-content-center">
              <img
                src={user.plataform.urlLogo ? user.plataform.urlLogo : spaik}
                style={{ maxWidth: "25px", maxHeight: "25px" }}
              />
            </div>

            <div
              className="ml-1"
              style={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#046AF3"
              }}
            >
              Interação do robô
            </div>
            <Span>?</Span>
          </div>
        </div>

        <div className="content mt-4 ml-2">
          {nodeSelectedFallBack?.length ? (
            nodeSelectedFallBack?.map((el, index) => (
              <Baloon expanded={"1rem"} key={index}>
                <img
                  css={ImageSixPoints}
                  src={SixPoints}
                  alt="icon-six-points"
                />
                <TextArea
                  autoFocus={true}
                  value={el}
                  ref={autoResize}
                  onChange={(e) => {
                    autoResize(e.target);
                    handleUpdate(e, index);
                  }}
                  onKeyDown={handleKeyPress}
                  onKeyUp={(e) => {
                    setActiveFallbackIndex(index);
                    setCursorPosition(e.currentTarget.selectionStart ?? 0);
                  }}
                  onClick={(e) => {
                    setActiveFallbackIndex(index);
                    setCursorPosition(e.currentTarget.selectionStart ?? 0);
                  }}
                  onSelect={(e) => {
                    setActiveFallbackIndex(index);
                    setCursorPosition(e.currentTarget.selectionStart ?? 0);
                  }}
                  placeholder="Insira sua mensagem de fallback aqui..."
                />

                <button
                  // onClick={handleAddFallbackMessage}
                  onClick={showOptions}
                  type="button"
                  css={ButtonPlus}
                >
                  +
                </button>

                {nodeSelectedFallBack?.length > 1 ? (
                  <button
                    type="button"
                    onClick={() => handleDelete(index)}
                    css={ButtonTrash}
                  >
                    <img src={ButtonDelete} alt="icon-button-delete" />
                  </button>
                ) : null}
              </Baloon>
            ))
          ) : (
            <Baloon expanded={"1rem"}>
              <img css={ImageSixPoints} src={SixPoints} alt="icon-six-points" />
              <TextArea
                autoFocus={true}
                value={firstFallbackMessage}
                ref={autoResize}
                onChange={(e) => {
                  autoResize(e.target);
                  setFirstFallbackMessage(e.target.value);
                }}
                onKeyDown={handleKeyPress}
                onKeyUp={(e) => {
                  setActiveFallbackIndex(-1);
                  setCursorPosition(e.currentTarget.selectionStart ?? 0);
                }}
                onClick={(e) => {
                  setActiveFallbackIndex(-1);
                  setCursorPosition(e.currentTarget.selectionStart ?? 0);
                }}
                onSelect={(e) => {
                  setActiveFallbackIndex(-1);
                  setCursorPosition(e.currentTarget.selectionStart ?? 0);
                }}
                placeholder="Insira sua mensagem de fallback aqui..."
              />
              <button
                // onClick={handleAddFallbackMessage}
                onClick={showOptions}
                type="button"
                css={ButtonPlus}
              >
                +
              </button>
            </Baloon>
          )}
          <div className="flex justify-content-between">
            <div className="flex gap-2">
              <img src={Actions} alt="Actions-Icon" />
              <Text lh="21px" color="#046AF3" s="0.875rem">
                Ações
              </Text>
            </div>
            <div>
              <div css={Flex}>
                {/* <img src={A} alt="Icon-text-edit" /> */}
                <ImgIcon
                  onClick={() => {
                    dispatch(setIdxEmoji(fallbackEmojiIdx));
                    dispatch(setEmojiModalOpen(true));
                  }}
                  className="tooltip-Smile"
                  data-pr-position="bottom"
                >
                  <img src={Smile} alt="Icon-Smiles" />
                </ImgIcon>
                <Tooltip target=".tooltip-Smile">Enviar Emoji</Tooltip>
                {/* <img src={Attachment} alt="Icon-Attachment" />
                <img src={Link} alt="Icon-Link" />
                <img src={MicBlue} alt="Icon-MicBlue" />
                <img src={ThreePointsBlue} alt="Icon-ThreePointsBlue" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-white"
        style={{
          border: "1px solid #EEE",
          marginTop: "1rem",
          marginBottom: "1rem"
        }}
      />
    </div>
  );
};
